import { AgentsTblKeys } from "../../agents.constants";

export const COLUMN_CONFIG: { key: AgentsTblKeys; title: string; width: number }[] = [
    { key: AgentsTblKeys.CREATED_ON, title: "Created On", width: 150 },
    { key: AgentsTblKeys.IS_ACTIVE, title: "Status", width: 110 },
    { key: AgentsTblKeys.NAME, title: "Name", width: 160 },
    { key: AgentsTblKeys.EMAIL, title: "Email", width: 200 },
    { key: AgentsTblKeys.CELL_NUMBER, title: "Cell Number", width: 140 },
    { key: AgentsTblKeys.USER_TYPE, title: "User Type", width: 130 },
    { key: AgentsTblKeys.BUSINESS_NAME, title: "Business Name", width: 160 },
    { key: AgentsTblKeys.WRITING_NUMBER, title: "Writing Number", width: 170 },
    { key: AgentsTblKeys.AGENCY_NUMBER, title: "Agency Number", width: 160 },
    { key: AgentsTblKeys.LAST_LOGIN_ON, title: "Last Login", width: 150 },
];
